import { createReducer, on } from '@ngrx/store';

import {
  BasicVerificationStatus,
  IDVerificationStatus,
} from '../../models/verification-profile-response';
import * as summaryAction from '../actions/summary';
import { Logout, LoadingState } from '@personal-area/global/state';

export type SummaryState = {
  basicStatus: BasicVerificationStatus;
  idStatus: IDVerificationStatus;
  basicTrialExpirationDate: Date;
  idCompleteExpirationDate: Date;
  loadingState: LoadingState;
};

const initialState: SummaryState = {
  basicStatus: BasicVerificationStatus.none,
  idStatus: IDVerificationStatus.none,
  basicTrialExpirationDate: new Date(),
  idCompleteExpirationDate: new Date(),
  loadingState: LoadingState.initial,
};

export const summaryReducer = createReducer(
  initialState,
  on(summaryAction.GetSummary, (state) => ({
    ...state,
    loadingState: LoadingState.loading,
  })),
  on(summaryAction.GetSummarySuccess, (_state, response) => ({
    basicStatus: response.basicVerificationStatus === BasicVerificationStatus.none && response.isBasicFormPassed
      ? BasicVerificationStatus.basicFormPassed
      : response.basicVerificationStatus,
    idStatus: response.idVerificationStatus,
    basicTrialExpirationDate: new Date(response.basicTrialExpirationDate),
    idCompleteExpirationDate: new Date(response.statusWidgetDisplayExpirationDate),
    loadingState: LoadingState.loaded,
  })),
  on(summaryAction.GetSummaryFail, (state) => ({
    ...state,
    loadingState: LoadingState.failed,
  })),
  on(summaryAction.ExpireBanner, (state) => ({
    ...state,
    idCompleteExpirationDate: new Date(0),
  })),
  on(summaryAction.MergeStatus, (state, status) => ({
    ...state,
    ...status,
  })),
  on(Logout, state => initialState),
);
